export const ACTIVITIES_URL = '/admin/v2/activities';
export const ACTIVITIES_TYPES_URL = '/admin/v2/activities/types';
export const ACTIVITIES_ORG_URL = '/admin/v2/activities/organizations';
